export default "__VITE_ASSET__DXoOHAvX__"